export default __webpack_public_path__ + "static/media/factory__56.e73517e3.jpg";